module.exports = "pegasus_template/assets/blocks/column-3-tech.png";